import React, {useContext, useState} from 'react';
import {
  ScrollView,
  NativeSyntheticEvent,
  TextInputChangeEventData,
} from 'react-native';
import Screen from '../../styled-components/Screen';
import PlansContext from '../../contexts/PlansContext';
import {RouteProp, useRoute, useNavigation} from '@react-navigation/core';
import {ContactsStackParamList} from './ContactRoutes';
import {Contact} from '../../database/schemas/contact';
import ContactListItem from './ContactListItem';
import InputBox, {TextInput} from '../general/InputBox';
import debounce from 'lodash/debounce';
import {NativeStackNavigationProp} from 'react-native-screens/lib/typescript/types';
import {Header, Title} from '../../styled-components/Header';
import NotFound from '../general/NotFound';
import {Text} from 'react-native';
import {ListItem} from '../../styled-components/List';

type ContactListRouteProp = RouteProp<ContactsStackParamList, 'ContactList'>;

const ContactList = () => {
  const {
    params: {planId},
  } = useRoute<ContactListRouteProp>();
  const navigation = useNavigation<
    NativeStackNavigationProp<ContactsStackParamList>
  >();
  const [searchTerm, setSearchTerm] = useState('');
  const context = useContext(PlansContext);
  const contacts = context!.doa.searchContacts(planId, searchTerm);

  const handleChange = debounce((value: string) => {
    if (value) {
      setSearchTerm(value);
    } else {
      setSearchTerm('');
    }
  }, 300);

  return (
    <>
      <Header>
        <Title>Contacts</Title>
        <InputBox background="rgba(0, 0, 0, 0.2)" color="white" icon="search">
          <TextInput
            autoCapitalize="none"
            color="white"
            placeholder="Search"
            placeholderTextColor="white"
            autoCompleteType="off"
            onChange={(e: NativeSyntheticEvent<TextInputChangeEventData>) =>
              handleChange(e.nativeEvent.text)
            }
          />
        </InputBox>
      </Header>
      <ScrollView>
        <Screen>
          {!!contacts.length ? (
            contacts.map((contact: Contact) => (
              <ListItem
                key={contact.id}
                onPress={() =>
                  navigation.push('Contact', {planId, contactId: contact.id})
                }>
                <ContactListItem key={contact.id} contact={contact} />
              </ListItem>
            ))
          ) : (
            <NotFound>
              <Text>No results from "{searchTerm}"</Text>
            </NotFound>
          )}
        </Screen>
      </ScrollView>
    </>
  );
};

export default ContactList;
